export default "__VITE_ASSET__iKcTrPwm__"